import { Radio as AntRadio } from "antd";

const RadioButtonGroup = AntRadio.Group;

export default RadioButtonGroup;
